'use client';

import Link from '@eliadmin/core/src/components/link';
import { usePathname, useRouter } from 'next/navigation';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Button } from '../ui/button';
import { useModal } from '../ui/modal';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export function PartnerButton({ className }: { className?: string }) {
  const pathname = usePathname();
  const router = useRouter();
  const modal = useModal();
  const { t } = useTranslations();

  function handleClick(e: React.MouseEvent) {
    e.preventDefault();
    modal?.close();
    router.push(`${pathname}#contact`);
  }

  return (
    <Button asChild variant="partner" className={cn('text-center', className)}>
      <Link prefetch={false} href={`${pathname}#contact`} onClick={handleClick}>
        {t('text3536')}
      </Link>
    </Button>
  );
}
